<div class="activity-section p-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h3 class="mb-0">Atividade Recente</h3>
    <div class="d-flex gap-2">
      <button
        type="button"
        class="sf-btn sf-btn--secondary sf-btn--sm"
        (click)="openTestEventModal()"
        [appLoadingButton]="sendingTest"
        [disabled]="isBusy"
        data-testid="activity-send-test"
      >
        <i class="fa fa-flask"></i> Enviar evento de teste
      </button>
      <button
        type="button"
        class="sf-btn sf-btn--ghost sf-btn--sm"
        (click)="loadActivity()"
        [appLoadingButton]="isLoading"
        [disabled]="isBusy"
        data-testid="activity-refresh"
      >
        <i class="fa fa-refresh"></i> Atualizar
      </button>
    </div>
  </div>

  <!-- Esqueleto da lista (CU-86akkubzz): a tela saiu do overlay global. -->
  <app-skeleton *ngIf="isLoading" variant="card" [count]="3"
    label="Carregando a atividade recente" data-testid="activity-loading"></app-skeleton>

  <!-- Filters -->
  <div class="row mb-3" *ngIf="!isLoading && activity.length > 0">
    <div class="col-md-6">
      <div class="input-group input-group-sm">
        <span class="input-group-text"><i class="fa fa-search"></i></span>
        <input
          type="text"
          class="form-control"
          placeholder="Pesquisar em payload..."
          [(ngModel)]="filterSearchText"
          (ngModelChange)="onFilterChange()"
        />
      </div>
    </div>
    <div class="col-md-6">
      <div class="d-flex gap-2">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="filterErrors"
            [(ngModel)]="filterShowErrors"
            (ngModelChange)="onFilterChange()"
          />
          <label class="form-check-label" for="filterErrors">
            Mostrar apenas erros
          </label>
        </div>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="filterTests"
            [(ngModel)]="filterShowTests"
            (ngModelChange)="onFilterChange()"
          />
          <label class="form-check-label" for="filterTests">
            Mostrar apenas testes
          </label>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && activity.length === 0" class="alert alert-info">
    <i class="fa fa-info-circle me-2"></i>
    Nenhum evento recebido ainda. Aguardando o primeiro webhook.
  </div>

  <!-- Activity list -->
  <div class="activity-list" *ngIf="!isLoading && filteredActivity.length > 0">
    <div
      *ngFor="let item of filteredActivity; trackBy: trackByReceivedAt"
      class="card mb-3"
    >
      <div
        class="card-header d-flex justify-content-between align-items-center"
        role="button"
      >
        <div class="d-flex gap-2 align-items-center flex-grow-1">
          <small class="text-muted">{{ formatDate(item.received_at) }}</small>
          <span class="badge" [ngClass]="getStatusClass(item.status)">
            {{ getStatusLabel(item.status) }}
          </span>
          <span *ngIf="item.is_test" class="badge bg-info">TEST</span>
          <span *ngIf="item.matched_event" class="badge bg-primary">
            {{ item.matched_event }}
          </span>
        </div>
        <button
          type="button"
          class="sf-btn sf-btn--secondary sf-btn--sm"
          (click)="reprocessItem(item)"
          [appLoadingButton]="reprocessingAt === item.received_at"
          [disabled]="isBusy"
          title="Re-processar este evento"
        >
          <i class="fa fa-repeat"></i> Re-processar
        </button>
      </div>

      <div class="card-body">
        <div class="row mb-2" *ngIf="item.lead_id">
          <div class="col-md-6">
            <strong>Lead ID:</strong> <code>{{ item.lead_id }}</code>
          </div>
        </div>
        <div class="row mb-2" *ngIf="item.target_lead_list">
          <div class="col-md-6">
            <strong>Lista alvo:</strong> <code>{{ item.target_lead_list }}</code>
          </div>
        </div>

        <div class="mt-3">
          <details>
            <summary class="cursor-pointer fw-bold">
              <i class="fa fa-code me-1"></i> Payload
            </summary>
            <pre
              class="mt-2 p-2 rounded payload"
              style="font-size: 0.85rem; max-height: 300px; overflow-y: auto"
            >{{ item.payload | json }}</pre>
          </details>
        </div>
      </div>
    </div>
  </div>

  <!-- No results from filter -->
  <div *ngIf="!isLoading && activity.length > 0 && filteredActivity.length === 0" class="alert alert-warning">
    <i class="fa fa-filter me-2"></i>
    Nenhum resultado corresponde aos filtros aplicados.
  </div>
</div>
